export default __webpack_public_path__ + "static/media/Blackpast.dd362012.otf";